import React, { useEffect, useState, useCallback } from 'react';
import { supabase } from '../../supabaseClient';

export default function TemplatePicker({ poolId, userId, lang = 'en' }) {
  const t = lang === 'fr' ? TR.fr : TR.en;
  const [templates, setTemplates] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const fetchData = useCallback(async () => {
    const [{ data: tpls }, { data: member }] = await Promise.all([
      supabase.from('user_queue_templates').select('id, name').eq('user_id', userId).order('name'),
      supabase.from('pool_members').select('active_template_id')
        .eq('pool_id', poolId).eq('user_id', userId).maybeSingle(),
    ]);
    setTemplates(tpls || []);
    setActiveId(member?.active_template_id || null);
  }, [poolId, userId]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleChange = async (e) => {
    const newId = e.target.value || null;
    setActiveId(newId);
    setSaving(true); setError('');
    const { data, error: rpcErr } = await supabase.rpc('set_pool_template', {
      p_user_id: userId, p_pool_id: poolId, p_template_id: newId,
    });
    setSaving(false);
    if (rpcErr) { setError(rpcErr.message); fetchData(); return; }
    if (!data?.success) { setError(data?.error || t.errSet); fetchData(); return; }
  };

  return (
    <div className="template-picker">
      <label>
        <span className="template-picker-label">{t.autoPickLabel}</span>
        <select value={activeId || ''} onChange={handleChange} disabled={saving}>
          <option value="">{t.none}</option>
          {templates.map((tpl) => (
            <option key={tpl.id} value={tpl.id}>{tpl.name}</option>
          ))}
        </select>
      </label>
      {templates.length === 0 && (
        <span className="template-picker-hint">{t.noTemplates}</span>
      )}
      {error && <span className="template-picker-error">{error}</span>}
    </div>
  );
}

const TR = {
  en: {
    autoPickLabel: 'Auto-pick from queue:',
    none: 'None (skip turn on timeout)',
    noTemplates: 'Build a queue in "My Queues" first.',
    errSet: 'Could not set template',
  },
  fr: {
    autoPickLabel: 'Sélection auto depuis la liste:',
    none: 'Aucune (passer le tour)',
    noTemplates: 'Créez d\'abord une liste dans « Mes listes ».',
    errSet: 'Impossible de définir la liste',
  },
};
